export var EGeoLevelDataAction;
(function (EGeoLevelDataAction) {
    EGeoLevelDataAction["NULL"] = "NULL";
    EGeoLevelDataAction["SET_GEO_TAG"] = "SET_GEO_TAG";
    EGeoLevelDataAction["REMOVE_GEO_TAG"] = "REMOVE_GEO_TAG";
    EGeoLevelDataAction["CHANGE_LVL_CLASSIFICATION"] = "CHANGE_LVL_CLASSIFICATION";
    EGeoLevelDataAction["EDIT_SHAPE"] = "EDIT_SHAPE";
    EGeoLevelDataAction["RENAME"] = "RENAME";
    EGeoLevelDataAction["EDIT_DATA"] = "EDIT_DATA";
    EGeoLevelDataAction["LOWER_LEVEL_TYPE"] = "LOWER_LEVEL_TYPE";
    EGeoLevelDataAction["RAISE_LEVEL_TYPE"] = "RAISE_LEVEL_TYPE";
    EGeoLevelDataAction["REMOVE"] = "REMOVE";
    EGeoLevelDataAction["DISABLE"] = "DISABLE";
    EGeoLevelDataAction["REDIRECT_TO_PARENT"] = "REDIRECT_TO_PARENT";
    EGeoLevelDataAction["REDIRECT_TO_CUSTOM"] = "REDIRECT_TO_CUSTOM";
    EGeoLevelDataAction["ABSORB_CHILDREN"] = "ABSORB_CHILDREN";
})(EGeoLevelDataAction || (EGeoLevelDataAction = {}));
export var EGeoLevelLevelType;
(function (EGeoLevelLevelType) {
    EGeoLevelLevelType["sub_suburb"] = "sub_suburb";
    EGeoLevelLevelType["suburb"] = "suburb";
    EGeoLevelLevelType["town"] = "town";
    EGeoLevelLevelType["city"] = "city";
    EGeoLevelLevelType["metropolitan_municipality"] = "metropolitan_municipality";
    EGeoLevelLevelType["local_municipality"] = "local_municipality";
    EGeoLevelLevelType["district_municipality"] = "district_municipality";
    EGeoLevelLevelType["province"] = "province";
    EGeoLevelLevelType["country"] = "country";
    EGeoLevelLevelType["continent"] = "continent";
})(EGeoLevelLevelType || (EGeoLevelLevelType = {}));
export var EGeoLevelShortLevel;
(function (EGeoLevelShortLevel) {
    EGeoLevelShortLevel["country_alone"] = "country_alone";
    EGeoLevelShortLevel["country_canonical"] = "country_canonical";
    EGeoLevelShortLevel["state_alone"] = "state_alone";
    EGeoLevelShortLevel["state_canonical"] = "state_canonical";
    EGeoLevelShortLevel["municipal_alone"] = "municipal_alone";
    EGeoLevelShortLevel["inapplicable"] = "inapplicable";
})(EGeoLevelShortLevel || (EGeoLevelShortLevel = {}));
export var ENodeSubTypeGeoLevel;
(function (ENodeSubTypeGeoLevel) {
    ENodeSubTypeGeoLevel["gl_ss"] = "gl_ss";
    ENodeSubTypeGeoLevel["gl_su"] = "gl_su";
    ENodeSubTypeGeoLevel["gl_ci"] = "gl_ci";
    ENodeSubTypeGeoLevel["gl_mu"] = "gl_mu";
    ENodeSubTypeGeoLevel["gl_st"] = "gl_st";
    ENodeSubTypeGeoLevel["gl_cc"] = "gl_cc";
    ENodeSubTypeGeoLevel["gl_cn"] = "gl_cn";
})(ENodeSubTypeGeoLevel || (ENodeSubTypeGeoLevel = {}));
export var EGeoLevelRedirect;
(function (EGeoLevelRedirect) {
    EGeoLevelRedirect["gl_ci"] = "gl_ci";
    EGeoLevelRedirect["gl_su"] = "gl_su";
})(EGeoLevelRedirect || (EGeoLevelRedirect = {}));
